export default "__VITE_ASSET__BOyqIXR1__ 100w";